export default {
    newDesign: true,
    title: "¡Responde 6 preguntas cortas y obtén una clase de matemáticas GRATIS! | Kodland",
    parameters: {
      landing_id: "SpMathN",
      segment: 10,
      success_page: 'success_long',
    },
    downtimeUrl: "https://www.kodland.org/es",
    startPage: {
        title: "¡Responde 6 preguntas cortas y obtén una clase de matemáticas GRATIS!",
        subtitle: "✏️ Para niños de 8 a 17 años<br>💬 Discutir los pasatiempos y experiencias del niño<br>🌐 Solo necesitas una computadora y conexión a internet",
        image: {
            url: "/welcome/math_freetc_latam_new_desk.png",
            style: {
                height: "100%",
                "max-height": "100vh",
            },
        },
        imageMobile: {
            url: "/welcome/math_freetc_latam_new_mob.png",
            style: {
                width: "100%",
            },
        },
        button: " ¡Vamos! ",
    },
    stopPage: {
        image: "/welcome/quizV2/no-computer.png",
        title: "¡Gracias por confiar en nuestra plataforma educativa!",
        subtitle:
            "Desafortunadamente, las tabletas o los teléfonos no son adecuados para tomar nuestras lecciones. ¡Estaremos felices de verlos en nuestras clases la próxima vez!",
    },
    quizRotateBySteps: {
        1: {
            title: "Elige la edad de tu hijo.",
            type: "age",
            subtitle: "Cientos de miles de padres nos han confiado para mejorar el rendimiento de sus hijos en matemáticas.",
            button: "",
        },
        2: {
            question: "Qué opina tu hijo/a sobre las matemáticas?",
            answers: [
                "😍 ¡Le encanta!",
                "🙂 Necesita un poco de motivación.",
                "😕 Tiene dificultades y suele evitarlo.",
                "🤔 No le gusta, quiere cambiarlo.",
            ],
        },
        3: {
            question: "¿Qué opinas, es importante que los niños dominen todo el conocimiento académico?",
            answers: [
                "📏 ¡Es muy importante!",
                "🖌️ Es importante, pero la creatividad también lo es.",
                "😃 Los niños deben disfrutar aprender, no solo preocuparse por las calificaciones.",
                "🤔 Los niños deben estar preparados para enfrentar el futuro.",
            ],
        },
        4: {
            question: "¿Qué le gusta a tu hijo/a al aprender?",
            answers: [
                "🕹️ Método de aprender jugando.",
                "📋 Explicaciones paso a paso.",
                "👥 Aprender en grupos pequeños.",
                "👨‍🏫 Un tutor que inspire.",
                "🙌 Todo lo anterior.",
            ],
        },
        5: {
            question:
                "¿Tiene su hijo/a una computadora o laptop que pueda usar para aprender?",
            answers: [
                "👍 Sí",
                {
                    answer: "👎 No",
                    stopAnswer: true,
                },
            ],
        },
        6: {
            typeInfo: "noQuestions",
            subtitle: "¡Nuestros tutores hacen que las matemáticas sean divertidas y fáciles de entender! Elige el horario para la clase GRATIS.",
            button: "Elige el horario de la clase 🕒",
        },
        7: {
            title: "Reserva una clase gratuita",
            type: "one-page-contacts",
            subtitle: "",
            button: "Casi terminamos 🔥",
        },
        8: {
            title: "",
            type: "timeslot",
            subtitle: "",
            button: "",
        },
        9: {
            title:
                "Revisa estos detalles para completar el registro ✨",
            typeInfo: "pc-laptop",
            subtitle:
                "Ten en cuenta que para la lección necesitaras una PC o laptop en funcionamiento y que deberás acompañar a tu hijo/a durante toda la clase. Recuerda que la misma es individual y personalizada.",
            button: "¿Qué más?",
        },
        10: {
            title: "Chequea tu correo y WhatsApp antes de la clase de prueba📞",
            typeInfo: "whatsapp",
            subtitle:
                "24hs antes estaremos enviándote un recordatorio y 2 horas antes de la clase te pediremos que confirmes tu asistencia. Es muy importante que estemos en contacto para que la clase no se cancele.",
            button: "¿Qué más?",
        },
        11: {
            title: "La clase se realizará en nuestra plataforma 💻",
            typeInfo: "classroom",
            subtitle:
              "Recibirás un enlace y un código único por WhatsApp y correo electrónico. Solo haz clic en el enlace y te llevará directo a la clase. Sin apps adicionales, sin descargas.",
            button: "Entendido ✅",
        },
    },
};
